import { graphql } from 'gatsby'

import { kebabCase } from 'lodash'
import React from 'react'

import { FlowGallery } from '../components/FlowGallery/FlowGallery'

const FlowGalleryPage = ({
  data,
  pageContext: { slug, category, totalCount }
}) => {
  const imageData = data.allMdx.nodes.map(
    ({
      fields: { slug: pageSlug },
      frontmatter: { title, author, gallery_images }
    }) => {
      return {
        slug: pageSlug,
        href: `/flow/gallery/${kebabCase(title)}`,
        title,
        author,
        galleryImages: [...gallery_images]
      }
    }
  )

  return (
    <FlowGallery
      slug={slug}
      category={category}
      categories={data.categories.group}
      totalCount={totalCount}
      imageData={imageData}
    />
  )
}

export default FlowGalleryPage

export const pageQuery = graphql`
  query FlowGallery($category: String!) {
    allMdx(filter: { frontmatter: { category: { eq: $category } } }) {
      nodes {
        fields {
          slug
        }
        frontmatter {
          title
          author
          date
          description
          gallery_images {
            childImageSharp {
              ...flowGalleryImage
            }
          }
          category
        }
      }
    }
    categories: allMdx(
      filter: { fields: { slug: { glob: "/flowgallery/**" } } }
    ) {
      group(field: { frontmatter: { category: SELECT } }) {
        label: fieldValue
        totalCount
      }
    }
  }
`
